import { render, staticRenderFns } from "./noticeImg.vue?vue&type=template&id=1d2c05d8&scoped=true&"
import script from "./noticeImg.vue?vue&type=script&lang=js&"
export * from "./noticeImg.vue?vue&type=script&lang=js&"
import style0 from "./noticeImg.vue?vue&type=style&index=0&id=1d2c05d8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d2c05d8",
  null
  
)

export default component.exports